<page-title text="{{currency?.name}} Price Chart ({{currency?.code}}) | BitOasis" i18n-text="@@pageTitle.pricePage"></page-title>

<ng-container [ngSwitch]="currency?.code">
  <ng-container *ngSwitchCase="'BTC'">
    <page-meta description="BTC Brief Description" i18n-description="@@pricePage.brief.BTC"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'BCH'">
    <page-meta description="BCH Brief Description" i18n-description="@@pricePage.brief.BCH"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'ETH'">
    <page-meta description="ETH Brief Description" i18n-description="@@pricePage.brief.ETH"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'ETC'">
    <page-meta description="ETC Brief Description" i18n-description="@@pricePage.brief.ETC"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'LTC'">
    <page-meta description="LTC Brief Description" i18n-description="@@pricePage.brief.LTC"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'XRP'">
    <page-meta description="XRP Brief Description" i18n-description="@@pricePage.brief.XRP"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'XLM'">
    <page-meta description="XLM Brief Description" i18n-description="@@pricePage.brief.XLM"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'EOS'">
    <page-meta description="EOS Brief Description" i18n-description="@@pricePage.brief.EOS"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'ZRX'">
    <page-meta description="ZRX Brief Description" i18n-description="@@pricePage.brief.ZRX"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'BAT'">
    <page-meta description="BAT Brief Description" i18n-description="@@pricePage.brief.BAT"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'OMG'">
    <page-meta description="OMG Brief Description" i18n-description="@@pricePage.brief.OMG"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'ALGO'">
    <page-meta description="ALGO Brief Description" i18n-description="@@pricePage.brief.ALGO"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'USDT'">
    <page-meta description="USDT Brief Description" i18n-description="@@pricePage.brief.USDT"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'NEO'">
    <page-meta description="NEO Brief Description" i18n-description="@@pricePage.brief.NEO"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'XTZ'">
    <page-meta description="XTZ Brief Description" i18n-description="@@pricePage.brief.XTZ"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'LINK'">
    <page-meta description="LINK Brief Description" i18n-description="@@pricePage.brief.LINK"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'DAI'">
    <page-meta description="DAI Brief Description" i18n-description="@@pricePage.brief.DAI"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'KNC'">
    <page-meta description="KNC Brief Description" i18n-description="@@pricePage.brief.KNC"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'REP'">
    <page-meta description="REP Brief Description" i18n-description="@@pricePage.brief.REP"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'MKR'">
    <page-meta description="MKR Brief Description" i18n-description="@@pricePage.brief.MKR"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'YFI'">
    <page-meta description="YFI Brief Description" i18n-description="@@pricePage.brief.YFI"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'SNX'">
    <page-meta description="SNX Brief Description" i18n-description="@@pricePage.brief.SNX"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'COMP'">
    <page-meta description="COMP Brief Description" i18n-description="@@pricePage.brief.COMP"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'UNI'">
    <page-meta description="UNI Brief Description" i18n-description="@@pricePage.brief.UNI"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'BAL'">
    <page-meta description="BAL Brief Description" i18n-description="@@pricePage.brief.BAL"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'LRC'">
    <page-meta description="LRC Brief Description" i18n-description="@@pricePage.brief.LRC"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'ENJ'">
    <page-meta description="ENJ Brief Description" i18n-description="@@pricePage.brief.ENJ"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'MATIC'">
    <page-meta description="MATIC Brief Description" i18n-description="@@pricePage.brief.MATIC"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'MANA'">
    <page-meta description="MANA Brief Description" i18n-description="@@pricePage.brief.MANA"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'DOGE'">
    <page-meta description="DOGE Brief Description" i18n-description="@@pricePage.brief.DOGE"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'USDC'">
    <page-meta description="USDC Brief Description" i18n-description="@@pricePage.brief.USDC"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'BNT'">
    <page-meta description="BNT Brief Description" i18n-description="@@pricePage.brief.BNT"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'STORJ'">
    <page-meta description="STORJ Brief Description" i18n-description="@@pricePage.brief.STORJ"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'WAVES'">
    <page-meta description="WAVES Brief Description" i18n-description="@@pricePage.brief.WAVES"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'SUSHI'">
    <page-meta description="SUSHI Brief Description" i18n-description="@@pricePage.brief.SUSHI"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'AAVE'">
    <page-meta description="AAVE Brief Description" i18n-description="@@pricePage.brief.AAVE"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'SOL'">
    <page-meta description="SOL Brief Description" i18n-description="@@pricePage.brief.SOL"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'ADA'">
    <page-meta description="ADA Brief Description" i18n-description="@@pricePage.brief.ADA"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'LUNA'">
    <page-meta description="LUNA Brief Description" i18n-description="@@pricePage.brief.LUNA"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'DOT'">
    <page-meta description="DOT Brief Description" i18n-description="@@pricePage.brief.DOT"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'AVAX'">
    <page-meta description="AVAX Brief Description" i18n-description="@@pricePage.brief.AVAX"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'SHIB'">
    <page-meta description="SHIB Brief Description" i18n-description="@@pricePage.brief.SHIB"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'WBTC'">
    <page-meta description="WBTC Brief Description" i18n-description="@@pricePage.brief.WBTC"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'NEAR'">
    <page-meta description="NEAR Brief Description" i18n-description="@@pricePage.brief.NEAR"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'ATOM'">
    <page-meta description="ATOM Brief Description" i18n-description="@@pricePage.brief.ATOM"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'FTM'">
    <page-meta description="FTM Brief Description" i18n-description="@@pricePage.brief.FTM"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'DGB'">
    <page-meta description="DGB Brief Description" i18n-description="@@pricePage.brief.DGB"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'EGLD'">
    <page-meta description="EGLD Brief Description" i18n-description="@@pricePage.brief.EGLD"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'IOTA'">
    <page-meta description="IOTA Brief Description" i18n-description="@@pricePage.brief.IOTA"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'KSM'">
    <page-meta description="KSM Brief Description" i18n-description="@@pricePage.brief.KSM"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'AXS'">
    <page-meta description="AXS Brief Description" i18n-description="@@pricePage.brief.AXS"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'TRX'">
    <page-meta description="TRX Brief Description" i18n-description="@@pricePage.brief.TRX"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'OCEAN'">
    <page-meta description="OCEAN Brief Description" i18n-description="@@pricePage.brief.OCEAN"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'CHZ'">
    <page-meta description="CHZ Brief Description" i18n-description="@@pricePage.brief.CHZ"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'LEO'">
    <page-meta description="LEO Brief Description" i18n-description="@@pricePage.brief.LEO"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'QTUM'">
    <page-meta description="QTUM Brief Description" i18n-description="@@pricePage.brief.QTUM"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'THETA'">
    <page-meta description="THETA Brief Description" i18n-description="@@pricePage.brief.THETA"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'VET'">
    <page-meta description="VET Brief Description" i18n-description="@@pricePage.brief.VET"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'XVG'">
    <page-meta description="XVG Brief Description" i18n-description="@@pricePage.brief.XVG"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'1INCH'">
    <page-meta description="1INCH Brief Description" i18n-description="@@pricePage.brief.ONEINCH"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'ANT'">
    <page-meta description="ANT Brief Description" i18n-description="@@pricePage.brief.ANT"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'BAND'">
    <page-meta description="BAND Brief Description" i18n-description="@@pricePage.brief.BAND"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'CRV'">
    <page-meta description="CRV Brief Description" i18n-description="@@pricePage.brief.CRV"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'FTT'">
    <page-meta description="FTT Brief Description" i18n-description="@@pricePage.brief.FTT"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'GALA'">
    <page-meta description="GALA Brief Description" i18n-description="@@pricePage.brief.GALA"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'GNO'">
    <page-meta description="GNO Brief Description" i18n-description="@@pricePage.brief.GNO"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'GRT'">
    <page-meta description="GRT Brief Description" i18n-description="@@pricePage.brief.GRT"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'NEXO'">
    <page-meta description="NEXO Brief Description" i18n-description="@@pricePage.brief.NEXO"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'TUSD'">
    <page-meta description="TUSD Brief Description" i18n-description="@@pricePage.brief.TUSD"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'UST'">
    <page-meta description="UST Brief Description" i18n-description="@@pricePage.brief.UST"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'FIL'">
    <page-meta description="FIL Brief Description" i18n-description="@@pricePage.brief.FIL"></page-meta>
  </ng-container>
  <ng-container *ngSwitchCase="'ETHW'">
    <page-meta description="ETHW Brief Description" i18n-description="@@pricePage.brief.ETHW"></page-meta>
  </ng-container>



<site-layout>
  <loading *ngIf="loading" class="full">
    <ng-container i18n="@@pricePage.loading">Loading Data ...</ng-container>
  </loading>

  <error *ngIf="!loading && error" class="full">
    {{error}}
  </error>

  <div *ngIf="!loading && !error" class="wrapper">
    <nav class="breadcrumb p-3" aria-label="breadcrumb">
      <a routerLink="/home" i18n="@@breadcrumb.front.home">Home</a>
      <div class="separator"></div>
      <a routerLink="/prices" i18n="@@breadcrumb.front.prices">Prices</a>
      <div class="separator"></div>
      <span>{{currency?.name}}</span>
    </nav>

    <div class="top box">
      <header class="header row align-items-center">
        <div class="title col-lg col-12 d-flex align-items-center">
          <currency [currency]="currency?.code"></currency>
          <div class="p-1"></div>
          <span class="name">{{currency?.name}}</span>
          <div class="p-1"></div>
          <span class="code text-lg text-gray">{{currency?.code}}</span>
          <div class="p-1"></div>
          <!-- TODO: create a pipe for adding + -->
          <span class="text-bold ltr" [ngClass]="data?.isPositvitePriceChange ? 'change-badge-primary' : 'change-badge-danger'">{{data?.isPositvitePriceChange ? '+' : ''}}{{data?.priceChangePercentage || 0 | number: '0.2-2'}}%</span>
          <div class="p-1"></div>
          <price-alert-button location="Price Page" [pair]="pair" [useGlobalCurrency]="useGlobalCurrency"></price-alert-button>
        </div>
        <ng-container [ngSwitch]="mainCurrency">
          <ng-container *ngSwitchDefault="">
            <div class="col-lg-2 col-6 pt-3 pt-lg-0">
              <a routerLink="/lite/exchange/buy" [queryParams]="{to: mainCurrency, from: baseCurrency}"
                class="btn btn-primary btn-block" i18n="@@pricePage.action.buy">Buy {{mainCurrency}}</a>
            </div>
            <div class="col-lg-2 col-6 pt-3 pt-lg-0">
              <a routerLink="/lite/exchange/sell" [queryParams]="{from: mainCurrency, to: baseCurrency}"
                class="btn btn-danger btn-block" i18n="@@pricePage.action.sell">Sell {{mainCurrency}}</a>
            </div>
          </ng-container>
        </ng-container>
      </header><!-- .header -->

      <div class="chart-info row align-items-center">
        <div class="col-lg">
          <div class="price">
            <div class="item-price">
              <span class="text-bold">{{data?.defaultCurrency?.currency}} {{ data?.defaultCurrency?.lastPrice || 0 | number:'0.2-2'}}</span>
              <!-- TODO: create a pipe for adding + -->
              <span *ngIf="data?.defaultCurrency?.priceChange" class="text-primary text-sm ltr ms-1" [class.text-danger]="!data?.isPositvitePriceChange">
                ({{data?.isPositvitePriceChange ? '+' : ''}}{{data?.defaultCurrency?.priceChange | number:'0.2-2'}})
              </span>
            </div>
            <div *ngIf="useGlobalCurrency" class="item-price text-sm text-gray">
              <span class="text-md">{{data?.baseCurrency?.currency}} {{ data?.baseCurrency?.lastPrice || 0 | number:'0.2-2'}}</span>
              <!-- TODO: create a pipe for adding + -->
              <span *ngIf="data?.baseCurrency?.priceChange" class="text-primary text-sm ms-1" [class.text-danger]="!data?.isPositvitePriceChange">
                ({{data?.isPositvitePriceChange ? '+' : ''}}{{data?.baseCurrency?.priceChange | number:'0.2-2'}})
              </span>
            </div>
          </div>
        </div>
        <chart-duration-picker class="col-lg-auto" [duration]="duration" (durationChange)="changeDuration($event)"></chart-duration-picker>
      </div>
      <price-chart
        *ngIf="pair"
        class="chart"
        [data]="data?.livePriceHistory"
        [color]="data?.chartColor">
      </price-chart>
    </div><!-- .top -->
    <div class="row">
      <div class="col-lg-6">
        <div class="left box">
          <h3 class="box-title" i18n="@@pricePage.brief.title">What is {{currency?.name}}</h3>
          <p class="text">
            <ng-container *ngTemplateOutlet="brief"></ng-container>
          </p>
          <h4 class="subtitle" i18n="@@pricePage.website.title">Official Website</h4>
          <div class="link d-flex align-items-center">
            <img class="icon-lg" src="assets/images/icons/www.svg" alt="">
            <span class="p-1"></span>
            <ng-container *ngTemplateOutlet="website"></ng-container>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="right box">
          <h3 class="box-title" i18n="@@pricePage.otherDigitalAssets.title">Other Digital Assets</h3>
          <div class="currency-list">
            <a *ngFor="let currency of currencies" [routerLink]="['..', currency?.code + '-' + baseCurrency]" class="item d-flex align-items-center">
              <currency [currency]="currency?.code"></currency>
              <div class="p-1"></div>
              <div class="col"><span class="text-dark text-bold">{{currency?.name}}</span> <span class="ms-2 text-gray text-md">{{currency?.code}}</span></div>
              <div class="col">
                <div *ngIf="useGlobalCurrency">
                  <div *ngIf="currency?.currentUsdExchangeRate; else emptyPrice" class="col-auto">{{currency?.currentUsdExchangeRate?.currency}} {{currency?.currentUsdExchangeRate?.amount | number:'0.2-6'}}</div>
                </div>
                <div
                  *ngIf="currency?.currentExchangeRate; else emptyPrice"
                  class="col-auto"
                  [ngClass]="useGlobalCurrency ? ' text-sm text-gray' : ''">
                  {{baseCurrency}} {{currency?.currentExchangeRate?.amount | number:'0.2-6'}}
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div><!-- .wrapper -->
</site-layout>
<site-footer></site-footer>

<ng-template #emptyPrice>
  <div class="col-auto">--</div>
</ng-template>

<ng-template #brief>
  <ng-container [ngSwitch]="currency?.code">
    <ng-container *ngSwitchCase="'BTC'" i18n="@@pricePage.brief.BTC">BTC Brief Description</ng-container>
    <ng-container *ngSwitchCase="'BCH'" i18n="@@pricePage.brief.BCH">BCH Brief Description</ng-container>
    <ng-container *ngSwitchCase="'ETH'" i18n="@@pricePage.brief.ETH">ETH Brief Description</ng-container>
    <ng-container *ngSwitchCase="'ETC'" i18n="@@pricePage.brief.ETC">ETC Brief Description</ng-container>
    <ng-container *ngSwitchCase="'LTC'" i18n="@@pricePage.brief.LTC">LTC Brief Description</ng-container>
    <ng-container *ngSwitchCase="'XRP'" i18n="@@pricePage.brief.XRP">XRP Brief Description</ng-container>
    <ng-container *ngSwitchCase="'XLM'" i18n="@@pricePage.brief.XLM">XLM Brief Description</ng-container>
    <ng-container *ngSwitchCase="'EOS'" i18n="@@pricePage.brief.EOS">EOS Brief Description</ng-container>
    <ng-container *ngSwitchCase="'ZRX'" i18n="@@pricePage.brief.ZRX">ZRX Brief Description</ng-container>
    <ng-container *ngSwitchCase="'BAT'" i18n="@@pricePage.brief.BAT">BAT Brief Description</ng-container>
    <ng-container *ngSwitchCase="'OMG'" i18n="@@pricePage.brief.OMG">OMG Brief Description</ng-container>
    <ng-container *ngSwitchCase="'ALGO'" i18n="@@pricePage.brief.ALGO">ALGO Brief Description</ng-container>
    <ng-container *ngSwitchCase="'USDT'" i18n="@@pricePage.brief.USDT">USDT Brief Description</ng-container>
    <ng-container *ngSwitchCase="'NEO'" i18n="@@pricePage.brief.NEO">NEO Brief Description</ng-container>
    <ng-container *ngSwitchCase="'XTZ'" i18n="@@pricePage.brief.XTZ">XTZ Brief Description</ng-container>
    <ng-container *ngSwitchCase="'LINK'" i18n="@@pricePage.brief.LINK">LINK Brief Description</ng-container>
    <ng-container *ngSwitchCase="'DAI'" i18n="@@pricePage.brief.DAI">DAI Brief Description</ng-container>
    <ng-container *ngSwitchCase="'KNC'" i18n="@@pricePage.brief.KNC">KNC Brief Description</ng-container>
    <ng-container *ngSwitchCase="'REP'" i18n="@@pricePage.brief.REP">REP Brief Description</ng-container>
    <ng-container *ngSwitchCase="'MKR'" i18n="@@pricePage.brief.MKR">MKR Brief Description</ng-container>
    <ng-container *ngSwitchCase="'YFI'" i18n="@@pricePage.brief.YFI">YFI Brief Description</ng-container>
    <ng-container *ngSwitchCase="'SNX'" i18n="@@pricePage.brief.SNX">SNX Brief Description</ng-container>
    <ng-container *ngSwitchCase="'COMP'" i18n="@@pricePage.brief.COMP">COMP Brief Description</ng-container>
    <ng-container *ngSwitchCase="'UNI'" i18n="@@pricePage.brief.UNI">UNI Brief Description</ng-container>
    <ng-container *ngSwitchCase="'BAL'" i18n="@@pricePage.brief.BAL">BAL Brief Description</ng-container>
    <ng-container *ngSwitchCase="'LRC'" i18n="@@pricePage.brief.LRC">LRC Brief Description</ng-container>
    <ng-container *ngSwitchCase="'ENJ'" i18n="@@pricePage.brief.ENJ">ENJ Brief Description</ng-container>
    <ng-container *ngSwitchCase="'MATIC'" i18n="@@pricePage.brief.MATIC">MATIC Brief Description</ng-container>
    <ng-container *ngSwitchCase="'MANA'" i18n="@@pricePage.brief.MANA">MANA Brief Description</ng-container>
    <ng-container *ngSwitchCase="'DOGE'" i18n="@@pricePage.brief.DOGE">DOGE Brief Description</ng-container>
    <ng-container *ngSwitchCase="'USDC'" i18n="@@pricePage.brief.USDC">USDC Brief Description</ng-container>
    <ng-container *ngSwitchCase="'BNT'" i18n="@@pricePage.brief.BNT">BNT Brief Description</ng-container>
    <ng-container *ngSwitchCase="'STORJ'" i18n="@@pricePage.brief.STORJ">STORJ Brief Description</ng-container>
    <ng-container *ngSwitchCase="'WAVES'" i18n="@@pricePage.brief.WAVES">WAVES Brief Description</ng-container>
    <ng-container *ngSwitchCase="'SUSHI'" i18n="@@pricePage.brief.SUSHI">SUSHI Brief Description</ng-container>
    <ng-container *ngSwitchCase="'SOL'" i18n="@@pricePage.brief.SOL">SOL Brief Description</ng-container>
    <ng-container *ngSwitchCase="'ADA'" i18n="@@pricePage.brief.ADA">ADA Brief Description</ng-container>
    <ng-container *ngSwitchCase="'LUNA'" i18n="@@pricePage.brief.LUNA">LUNA Brief Description</ng-container>
    <ng-container *ngSwitchCase="'DOT'" i18n="@@pricePage.brief.DOT">DOT Brief Description</ng-container>
    <ng-container *ngSwitchCase="'AVAX'" i18n="@@pricePage.brief.AVAX">AVAX Brief Description</ng-container>
    <ng-container *ngSwitchCase="'SHIB'" i18n="@@pricePage.brief.SHIB">SHIB Brief Description</ng-container>
    <ng-container *ngSwitchCase="'WBTC'" i18n="@@pricePage.brief.WBTC">WBTC Brief Description</ng-container>
    <ng-container *ngSwitchCase="'NEAR'" i18n="@@pricePage.brief.NEAR">NEAR Brief Description</ng-container>
    <ng-container *ngSwitchCase="'ATOM'" i18n="@@pricePage.brief.ATOM">ATOM Brief Description</ng-container>
    <ng-container *ngSwitchCase="'FTM'" i18n="@@pricePage.brief.FTM">FTM Brief Description</ng-container>
    <ng-container *ngSwitchCase="'FIL'" i18n="@@pricePage.brief.FIL">FIL Brief Description</ng-container>
    <ng-container *ngSwitchCase="'DGB'" i18n="@@pricePage.brief.DGB">DGB Brief Description</ng-container>
    <ng-container *ngSwitchCase="'EGLD'" i18n="@@pricePage.brief.EGLD">EGLD Brief Description</ng-container>
    <ng-container *ngSwitchCase="'IOTA'" i18n="@@pricePage.brief.IOTA">IOTA Brief Description</ng-container>
    <ng-container *ngSwitchCase="'KSM'" i18n="@@pricePage.brief.KSM">KSM Brief Description</ng-container>
    <ng-container *ngSwitchCase="'AXS'" i18n="@@pricePage.brief.AXS">AXS Brief Description</ng-container>
    <ng-container *ngSwitchCase="'TRX'" i18n="@@pricePage.brief.TRX">TRX Brief Description</ng-container>
    <ng-container *ngSwitchCase="'OCEAN'" i18n="@@pricePage.brief.OCEAN">OCEAN Brief Description</ng-container>
    <ng-container *ngSwitchCase="'CHZ'" i18n="@@pricePage.brief.CHZ">CHZ Brief Description</ng-container>
    <ng-container *ngSwitchCase="'LEO'" i18n="@@pricePage.brief.LEO">LEO Brief Description</ng-container>
    <ng-container *ngSwitchCase="'QTUM'" i18n="@@pricePage.brief.QTUM">QTUM Brief Description</ng-container>
    <ng-container *ngSwitchCase="'THETA'" i18n="@@pricePage.brief.THETA">THETA Brief Description</ng-container>
    <ng-container *ngSwitchCase="'VET'" i18n="@@pricePage.brief.VET">VET Brief Description</ng-container>
    <ng-container *ngSwitchCase="'XVG'" i18n="@@pricePage.brief.XVG">XVG Brief Description</ng-container>
    <ng-container *ngSwitchCase="'1INCH'" i18n="@@pricePage.brief.ONEINCH">1INCH Brief Description</ng-container>
    <ng-container *ngSwitchCase="'ANT'" i18n="@@pricePage.brief.ANT">ANT Brief Description</ng-container>
    <ng-container *ngSwitchCase="'BAND'" i18n="@@pricePage.brief.BAND">BAND Brief Description</ng-container>
    <ng-container *ngSwitchCase="'CRV'" i18n="@@pricePage.brief.CRV">CRV Brief Description</ng-container>
    <ng-container *ngSwitchCase="'FTT'" i18n="@@pricePage.brief.FTT">FTT Brief Description</ng-container>
    <ng-container *ngSwitchCase="'GALA'" i18n="@@pricePage.brief.GALA">GALA Brief Description</ng-container>
    <ng-container *ngSwitchCase="'GNO'" i18n="@@pricePage.brief.GNO">GNO Brief Description</ng-container>
    <ng-container *ngSwitchCase="'GRT'" i18n="@@pricePage.brief.GRT">GRT Brief Description</ng-container>
    <ng-container *ngSwitchCase="'NEXO'" i18n="@@pricePage.brief.NEXO">NEXO Brief Description</ng-container>
    <ng-container *ngSwitchCase="'TUSD'" i18n="@@pricePage.brief.TUSD">TUSD Brief Description</ng-container>
    <ng-container *ngSwitchCase="'UST'" i18n="@@pricePage.brief.UST">UST Brief Description</ng-container>
    <ng-container *ngSwitchCase="'ETHW'" i18n="@@pricePage.brief.ETHW">ETHW Brief Description</ng-container>
  </ng-container>
</ng-template>

<ng-template #website>
  <ng-container [ngSwitch]="currency?.code">
    <a *ngSwitchCase="'BTC'" href="https://bitcoin.org" target="_blank">bitcoin.org</a>
    <a *ngSwitchCase="'BCH'" href="https://www.bitcoincash.org" target="_blank">bitcoincash.org</a>
    <a *ngSwitchCase="'ETH'" href="https://www.ethereum.org" target="_blank">ethereum.org</a>
    <a *ngSwitchCase="'ETC'" href="https://ethereumclassic.org" target="_blank">ethereumclassic.org</a>
    <a *ngSwitchCase="'LTC'" href="https://litecoin.com" target="_blank">litecoin.com</a>
    <a *ngSwitchCase="'XRP'" href="https://www.ripple.com" target="_blank">ripple.com</a>
    <a *ngSwitchCase="'XLM'" href="https://www.stellar.org" target="_blank">stellar.org</a>
    <a *ngSwitchCase="'EOS'" href="https://eos.io" target="_blank">eos.io</a>
    <a *ngSwitchCase="'ZRX'" href="https://0x.org" target="_blank">0x.org</a>
    <a *ngSwitchCase="'BAT'" href="https://basicattentiontoken.org" target="_blank">basicattentiontoken.org</a>
    <a *ngSwitchCase="'OMG'" href="https://omisego.co" target="_blank">omisego.co</a>
    <a *ngSwitchCase="'ALGO'" href="https://www.algorand.com" target="_blank">algorand.com</a>
    <a *ngSwitchCase="'USDT'" href="https://tether.to" target="_blank">tether.to</a>
    <a *ngSwitchCase="'NEO'" href="https://neo.org" target="_blank">neo.org</a>
    <a *ngSwitchCase="'XTZ'" href="https://tezos.com" target="_blank">tezos.com</a>
    <a *ngSwitchCase="'LINK'" href="https://chain.link" target="_blank">chain.link</a>
    <a *ngSwitchCase="'DAI'" href="https://makerdao.com" target="_blank">makerdao.com</a>
    <a *ngSwitchCase="'KNC'" href="https://kyber.network" target="_blank">kyber.network</a>
    <a *ngSwitchCase="'REP'" href="https://augur.net" target="_blank">augur.net</a>
    <a *ngSwitchCase="'MKR'" href="https://makerdao.com" target="_blank">makerdao.com</a>
    <a *ngSwitchCase="'YFI'" href="https://yearn.finance" target="_blank">yearn.finance</a>
    <a *ngSwitchCase="'SNX'" href="https://www.synthetix.io" target="_blank">synthetix.io</a>
    <a *ngSwitchCase="'COMP'" href="https://compound.finance" target="_blank">compound.finance</a>
    <a *ngSwitchCase="'UNI'" href="https://uniswap.org" target="_blank">uniswap.org</a>
    <a *ngSwitchCase="'BAL'" href="https://balancer.finance" target="_blank">balancer.finance</a>
    <a *ngSwitchCase="'LRC'" href="https://loopring.org" target="_blank">loopring.org</a>
    <a *ngSwitchCase="'ENJ'" href="https://enjincoin.io" target="_blank">enjincoin.io</a>
    <a *ngSwitchCase="'MATIC'" href="https://polygon.technology" target="_blank">polygon.technology</a>
    <a *ngSwitchCase="'MANA'" href="https://decentraland.org" target="_blank">decentraland.org</a>
    <a *ngSwitchCase="'DOGE'" href="https://dogecoin.com" target="_blank">dogecoin.com</a>
    <a *ngSwitchCase="'USDC'" href="https://www.circle.com/en/usdc" target="_blank">circle.com/usdc</a>
    <a *ngSwitchCase="'BNT'" href="https://www.bancor.network/" target="_blank">bancor.network</a>
    <a *ngSwitchCase="'STORJ'" href="https://www.storj.io" target="_blank">storj.io</a>
    <a *ngSwitchCase="'WAVES'" href="https://waves.tech" target="_blank">waves.tech</a>
    <a *ngSwitchCase="'SUSHI'" href="https://sushi.com" target="_blank">sushi.com</a>
    <a *ngSwitchCase="'AAVE'" href="https://aave.com" target="_blank">aave.com</a>
    <a *ngSwitchCase="'SOL'" href="https://solana.com" target="_blank">solana.com</a>
    <a *ngSwitchCase="'ADA'" href="https://cardano.org" target="_blank">cardano.org</a>
    <a *ngSwitchCase="'LUNA'" href="https://www.terra.money" target="_blank">www.terra.money</a>
    <a *ngSwitchCase="'DOT'" href="https://polkadot.network" target="_blank">polkadot.network</a>
    <a *ngSwitchCase="'AVAX'" href="https://www.avax.network" target="_blank">www.avax.network</a>
    <a *ngSwitchCase="'SHIB'" href="https://www.shibatoken.com" target="_blank">www.shibatoken.com</a>
    <a *ngSwitchCase="'WBTC'" href="https://www.wbtc.network" target="_blank">www.wbtc.network</a>
    <a *ngSwitchCase="'NEAR'" href="https://near.org" target="_blank">near.org</a>
    <a *ngSwitchCase="'ATOM'" href="https://cosmos.network" target="_blank">cosmos.network</a>
    <a *ngSwitchCase="'FIL'" href="https://filecoin.io" target="_blank">filecoin.io</a>
    <a *ngSwitchCase="'DGB'" href="https://digibyte.org" target="_blank">digibyte.org</a>
    <a *ngSwitchCase="'EGLD'" href="https://elrond.com" target="_blank">elrond.com</a>
    <a *ngSwitchCase="'IOTA'" href="https://www.iota.org" target="_blank">www.iota.org</a>
    <a *ngSwitchCase="'KSM'" href="https://kusama.network" target="_blank">kusama.network</a>
    <a *ngSwitchCase="'AXS'" href="https://axieinfinity.com" target="_blank">axieinfinity.com</a>
    <a *ngSwitchCase="'TRX'" href="https://tron.network" target="_blank">tron.network</a>
    <a *ngSwitchCase="'OCEAN'" href="http://www.oceanprotocol.com" target="_blank">www.oceanprotocol.com </a>
    <a *ngSwitchCase="'CHZ'" href="https://www.chiliz.com/en" target="_blank">www.chiliz.com</a>
    <a *ngSwitchCase="'LEO'" href="https://leo.bitfinex.com" target="_blank">leo.bitfinex.com</a>
    <a *ngSwitchCase="'QTUM'" href="http://www.qtum.org" target="_blank">qtum.org</a>
    <a *ngSwitchCase="'THETA'" href="https://www.thetatoken.org" target="_blank">www.thetatoken.org</a>
    <a *ngSwitchCase="'VET'" href="https://www.vechain.org" target="_blank">www.vechain.org</a>
    <a *ngSwitchCase="'XVG'" href="https://vergecurrency.com" target="_blank">vergecurrency.com</a>
    <a *ngSwitchCase="'1INCH'" href="https://1inch.io" target="_blank">1inch.io</a>
    <a *ngSwitchCase="'ANT'" href="https://aragon.org" target="_blank">aragon.org</a>
    <a *ngSwitchCase="'BAND'" href="https://bandprotocol.com" target="_blank">bandprotocol.com</a>
    <a *ngSwitchCase="'CRV'" href="https://curve.fi" target="_blank">curve.fi</a>
    <a *ngSwitchCase="'FTT'" href="https://ftx.com/FTT" target="_blank">ftx.com</a>
    <a *ngSwitchCase="'GALA'" href="https://app.gala.games" target="_blank">app.gala.games</a>
    <a *ngSwitchCase="'GNO'" href="https://gnosis.io" target="_blank">gnosis.io</a>
    <a *ngSwitchCase="'GRT'" href="https://thegraph.com/en" target="_blank">thegraph.com</a>
    <a *ngSwitchCase="'NEXO'" href="https://nexo.io" target="_blank">nexo.io</a>
    <a *ngSwitchCase="'TUSD'" href="https://trueusd.com" target="_blank">trueusd.com</a>
    <a *ngSwitchCase="'UST'" href="https://www.terra.money" target="_blank">www.terra.money</a>
    <a *ngSwitchCase="'ETHW'" href="https://ethereumpow.org/" target="_blank">ethereumpow.org/</a>
  </ng-container>
</ng-template>
